import { useContext } from 'react'
import { SuperpowersContext } from './SuperpowersContextDef'

export function useSuperpowers() {
  return useContext(SuperpowersContext)
}
